import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const setCloudId: YJSChangeHandler<DatabaseChangeType.SET_CLOUD_ID> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.cloudId = change.cloudId;
  });
};
